import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useFormik } from 'formik';

import { PromocodeForm } from '../components/PromocodeForm';
import { usePromocodeForm } from '../hooks/usePromocodeForm';
import { useAppDispatch, useAppSelector } from '../../../../../store';
import {
    selectPromocode,
    setPromocodeFormType,
} from '../store/promocode.slice';
import { useLazyReadPromocodeQuery } from '../service/promocode.api';
import { getValidationSchema, initialValues } from '../utils/fields';
import { Save } from '../../../widgets/Save';
import {
    PAGE_TYPE,
    PROMOCODE_FORM_TYPE,
} from '../service/promocodes.interface';
import { selectShopCurrent } from '../../shops/store/shopSlice';

export const PromocodeEdit = () => {
    const { promocodeId } = useParams();
    const { current: currentPromocode } = useAppSelector(selectPromocode);
    const current = useAppSelector(selectShopCurrent);
    const dispatch = useAppDispatch();

    const { formType } = useAppSelector(selectPromocode);

    const { onSubmit, isLoading } = usePromocodeForm({
        type: PAGE_TYPE.EDIT,
    });

    const [getPromocode] = useLazyReadPromocodeQuery();

    useEffect(() => {
        dispatch(setPromocodeFormType(PROMOCODE_FORM_TYPE.UNIQUE));
        if (promocodeId) {
            const payload = {
                shop_id: current?.id,
                id: +promocodeId,
            };
            getPromocode(payload, true);
        }
    }, [promocodeId, current?.id]);

    const formik = useFormik({
        initialValues: currentPromocode || initialValues,
        onSubmit: onSubmit,
        validationSchema: getValidationSchema(formType),
        validateOnChange: true,
        enableReinitialize: true,
    });

    return (
        <>
            <PromocodeForm formik={formik} />
            <Save
                onSave={() => {
                    void onSubmit(formik.values);
                }}
                disabled={isLoading || !formik.isValid}
                loading={isLoading}
            />
        </>
    );
};
